import React, { useEffect } from "react";
import useStyles from "./styles";
import { Badge, Link, Tooltip, Typography } from "@mui/material";
import mailIcon from "../../assets/svg/mail.svg";
import printIcon from "../../assets/svg/printer.svg";
import textIcon from "../../assets/svg/phone-chat-icon.svg";
import CustomButton from "../common/button/CustomButton";
import { InfoOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { getConfirmationToolTipAction } from "../../store/reducers/clientConfirmationSlice";
import { useSelector } from "react-redux";

// Define the props interface
interface PageActionButton {
  title: string;
  onClick?: () => void;
  disabled?: boolean;
  icon?: string;
  style?: React.CSSProperties;
  sx?: any;
}
interface PageInfoTitleProps {
  title: string;
  leadId?: string;
  subtitle?: string;
  desc?: string | React.ReactNode;
  urlLink?: string;
  isPrint?: boolean;
  isEmail?: boolean;
  isText?: boolean;
  button1?: string;
  button?: string;
   button3?: string;
  search?: boolean;
  editIcon?: boolean;
  isLogo?: boolean;
  disabled?: boolean;
  disabled1?: boolean;
  disabled3?: boolean;
  onClickPrintJobSheet?: () => void;
  onClickDownload?: () => void;
  onClick?: () => void;
  onClickEdit?: () => void;
  onClickButton1?: () => any;
  onClickButton3?: () => any;
  onClickEmailTemplate?: () => void;
  onClickSMSTemplate?: () => void;
  actionComponent?: React.ReactNode;

  buttons?: PageActionButton[];
}

const PageInfoTitle: React.FC<PageInfoTitleProps> = (props) => {
  const classes = useStyles();

  const { toolTipResponse } = useSelector((state: any) => state?.confirmation);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (props.leadId) {
  //     dispatch(getConfirmationToolTipAction(props.leadId));
  //   }
  // }, [props?.leadId]);

  return (
    <div
      className={
        props?.button === "Confirmation"
          ? classes.pageInfoButtonTitleContainer
          : classes.pageInfoTitleContainer
      }
    >
      <div style={{ display: "flow", textAlign: "left" }}>
        <Typography variant="h6" fontWeight={700} style={{ color: "#02906F" }}>
          {props.urlLink ? (
            <Link href={props.urlLink} underline="none">
              {props.subtitle}{" "}
            </Link>
          ) : (
            <>{props.subtitle} </>
          )}
          {props.title}
        </Typography>
        <Typography variant="subtitle1" fontWeight={600}>
          {props.desc}
        </Typography>
      </div>

      <div style={{ cursor: "pointer", display: "flex" }}>
        {/* Custom buttons from parent */}
        {props.actionComponent}
        {props.isPrint && (
          <CustomButton
            icon={printIcon}
            title={"Print"}
            onClick={props.onClickPrintJobSheet}
          />
          // <span style={{ display: "grid" }}>
          //   <Tooltip title="Print the Job Sheet" placement="top">
          //     <img
          //       src={printIcon}
          //       alt="logo"
          //       style={{ width: "20px", margin: "0px 10px", cursor: "pointer" }}
          //       onClick={props.onClickPrintJobSheet}
          //     />
          //   </Tooltip>
          //   <Typography
          //     variant="caption"
          //     fontWeight={600}
          //     style={{ color: "#108385" }}
          //   >
          //     Print
          //   </Typography>
          // </span>
        )}
        {props.isEmail && (
          <CustomButton
            icon={mailIcon}
            title={"Email"}
            onClick={props.onClickEmailTemplate}
            style={{ marginLeft: "10px" }}
          />
          // <span
          //   style={{ display: "grid" }}
          //   onClick={props.onClickEmailTemplate}
          // >
          //   <Tooltip
          //     title="Select an email to send to this customer"
          //     placement="top"
          //   >
          //     <img
          //       src={mailIcon}
          //       alt="logo"
          //       style={{ width: "20px", margin: "0px 10px", cursor: "pointer" }}
          //     />
          //   </Tooltip>
          //   <Typography
          //     variant="caption"
          //     fontWeight={600}
          //     style={{ color: "#108385" }}
          //   >
          //     Email
          //   </Typography>
          // </span>
        )}
        {props.isText && (
          <CustomButton
            icon={textIcon}
            title={"Text"}
            onClick={props.onClickSMSTemplate}
            style={{ marginLeft: "10px" }}
          />
          // <span style={{ display: "grid" }} onClick={props.onClickSMSTemplate}>
          //   <Tooltip
          //     title="Select a message to send SMS to this customer"
          //     placement="top"
          //   >
          //     <img
          //       src={textIcon}
          //       alt="logo"
          //       style={{ width: "20px", margin: "0px 10px" }}
          //     />
          //   </Tooltip>
          //   <Typography
          //     variant="caption"
          //     fontWeight={600}
          //     style={{ color: "#108385" }}
          //   >
          //     Text
          //   </Typography>
          // </span>
        )}
        {props.button && (
          <>
            <Badge
              badgeContent={
                props?.button === "Confirmation" &&
                toolTipResponse?.isSeen === false &&
                toolTipResponse?.isNewResponse === true ? (
                  <InfoOutlined />
                ) : (
                  0
                )
              }
              color="error"
              sx={{
                "& .MuiBadge-badge": {
                  // override the badge's default styling
                  backgroundColor: "red", // make the background transparent
                  color: "white", // use the icon's color
                  padding: 0, // remove padding around the icon
                  minWidth: "auto", // remove default badge width
                  height: "auto", // remove height constraint
                  borderRadius: "50%", // remove border radius
                  marginRight: "0px",
                },
              }}
            >
              <CustomButton
                disabled={
                  toolTipResponse?.isNewResponse ? false : props?.disabled
                }
                title={props.button}
                onClick={props.onClick}
                sx={{
                  width: {
                    xs: "318px",
                    sm: "100px",
                    "@media (min-width:1024px) and (max-width:1366px)": {
                      width: "150px", // 12-inch range
                    },
                    md: "170px",
                    "@media (min-width:1366px) and (max-width:1566px)": {
                      width: "170px",
                    },
                    lg: "200px",
                  },
                }}
                style={
                  props?.button === "Confirmation"
                    ? {
                        padding: "10px 30px",
                        height: "36px",
                        marginTop: "-4px",
                        // marginLeft: "-12px",
                        maxWidth: "100%",
                      }
                    : { padding: "10px 30px", height: "36px" }
                }
              />
            </Badge>
          </>
        )}
        {props.button1 && (
          <CustomButton
            disabled={props?.disabled1}
            style={{ marginLeft: "6px" }}
            title={props.button1}
            onClick={props.onClickButton1}
          />
        )}
        {props.button3 && (
          <CustomButton
            disabled={props?.disabled3}
            style={{ marginLeft: "6px" }}
            title={props.button3}
            onClick={props.onClickButton3}
          />
        )}

          {/* ---------------------------------------------------------------- */}
        {/* NEW: Dynamic Buttons                                              */}
        {/* ---------------------------------------------------------------- */}

        {props.buttons?.map((button, index) => (
          <CustomButton
            key={`${button.title}-${index}`}
            title={button.title}
            icon={button.icon}
            disabled={button.disabled}
            onClick={button.onClick}
            style={{
              marginLeft: "6px",
              ...button.style,
            }}
            sx={button.sx}
          />
        ))}

      </div>
    </div>
  );
};
// Set default props
PageInfoTitle.defaultProps = {
  isLogo: true,
};
export default PageInfoTitle;
